import { STATUS_COLORS } from "@/pages/workOrders/components/statusConstants";
import { Box, Tooltip, Typography } from "@mui/material";
import { EVENT_TYPES, getEventType } from "../config/eventTypes";
import {
	CARRIED_OVER_LABEL,
	CarriedOverIcon,
	PULLED_AHEAD_LABEL,
	PulledAheadIcon,
} from "./CarryMarker";
import { LegendSwatch } from "./LegendSwatch";

const WORK_ORDER_STATUSES = ["Pending", "Loaded", "Running", "Completed"];

// The system took the order off its planned shift; the bar stays on its plan
const CARRY_MARKS = [
	{
		label: CARRIED_OVER_LABEL,
		Icon: CarriedOverIcon,
		hint: "Did not run on its planned shift, so it moved to the current one",
	},
	{
		label: PULLED_AHEAD_LABEL,
		Icon: PulledAheadIcon,
		hint: "The queue ran dry, so it was taken ahead of its planned shift",
	},
];

export const CalendarLegend = () => (
	<Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 2 }}>
		{WORK_ORDER_STATUSES.map((status) => (
			<LegendSwatch
				key={status}
				label={status}
				bg={STATUS_COLORS[status].bg}
				border={STATUS_COLORS[status].color}
			/>
		))}
		{EVENT_TYPES.filter((t) => t.code !== "W").map((t) => (
			<LegendSwatch key={t.code} label={t.name} bg={t.bg} border={t.color} />
		))}
		<LegendSwatch
			label="Spell (line keeps running)"
			bg={getEventType("B").bg}
			border={getEventType("B").color}
			striped
		/>
		{CARRY_MARKS.map(({ label, Icon, hint }) => (
			<Tooltip key={label} title={hint}>
				<Box sx={{ display: "flex", alignItems: "center", gap: 0.25 }}>
					<Icon sx={{ fontSize: 16, color: "text.secondary" }} />
					<Typography variant="caption" color="text.secondary">
						{label}
					</Typography>
				</Box>
			</Tooltip>
		))}
	</Box>
);
